import {on} from 'delegated-events';

on('click', 'a[href="#"]', (e) => { e.preventDefault() });
